module.exports = __webpack_public_path__ + "_assets/img/barcode.ff1ae6cb.svg";